<div class="caption-bar">
  <div class="caption">Kalender</div>
  <div>
    <ion-button (click)="settingsButtonClicked()">
      <ion-icon size="large" name="layers-outline" slot="icon-only"></ion-icon>
    </ion-button>
    <ion-button (click)="addButtonClicked()">
      <ion-icon size="large" name="add" slot="icon-only"></ion-icon>
    </ion-button>
  </div>
</div>

@if (view) {
<div class="container">
  <div class="calendar-header">
    <div class="date-overview">
      {{ viewDate | calendarDate : view + "ViewTitle" : "de-DE" }}
    </div>
    <div class="switcher">
      <ion-icon
        mwlCalendarPreviousView
        [excludeDays]="excludeDays"
        [view]="view"
        [(viewDate)]="viewDate"
        size="small"
        name="chevron-back-outline"
        style="margin-right: 10px"
      ></ion-icon>
      <span mwlCalendarToday [(viewDate)]="viewDate" style="font-weight: 500">{{
        "calendar.today" | translate
      }}</span>
      <ion-icon
        mwlCalendarNextView
        [excludeDays]="excludeDays"
        [view]="view"
        [(viewDate)]="viewDate"
        size="small"
        name="chevron-forward-outline"
        style="margin-left: 10px"
      ></ion-icon>
    </div>
  </div>
  <!--div>
      <ion-segment
        value="buttons"
        [value]="view"
        (ionChange)="viewChanged($event)"
        >
        <ion-segment-button [value]="CalendarView.Day">
          <ion-label>Tag</ion-label>
        </ion-segment-button>
        <ion-segment-button [value]="CalendarView.Week">
          <ion-label>Woche</ion-label>
        </ion-segment-button>
        <ion-segment-button [value]="CalendarView.Month">
          <ion-label>Monat</ion-label>
        </ion-segment-button>
      </ion-segment>
    </div-->
  <div>
    @switch (view) { @case (CalendarView.Day) {
    <mwl-calendar-day-view
      [viewDate]="viewDate"
      [events]="events"
      [refresh]="refresh"
      [dayStartHour]="dayStartHour"
      [dayEndHour]="dayEndHour"
      (eventClicked)="handleEventClicked($event.event)"
    >
    </mwl-calendar-day-view>
    } @case (CalendarView.Week) {
    <mwl-calendar-week-view
      [viewDate]="viewDate"
      [refresh]="refresh"
      [events]="events"
      [dayStartHour]="dayStartHour"
      [dayEndHour]="dayEndHour"
      [excludeDays]="excludeDays"
      (eventClicked)="handleEventClicked($event.event)"
    >
    </mwl-calendar-week-view>
    } @case (CalendarView.Month) {
    <mwl-calendar-month-view
      [viewDate]="viewDate"
      [refresh]="refresh"
      [events]="events"
      [weekStartsOn]="weekStartsOn"
      (dayClicked)="dayClickedOnCalendar($event.day)"
    >
    </mwl-calendar-month-view>
    } }
  </div>
  <div class="event-list">
    @for (event of this.filteredEvents; track event) {
    <div
      class="event-list-item"
      [style.border-left-color]="event.color.secondary"
      (click)="handleEventClicked(event)"
    >
      <div>
        <!--ion-icon
            [style.color]="event.color.secondary"
            name="caret-forward"
            size="small"
          ></ion-icon>
          <span style="font-style: bold" [style.color]="event.color.secondary"
            >I</span
            -->{{ event.title }}
      </div>
      <div>
        <div>{{ tools.formatTime(event.start.toString()) }}</div>
        <div>{{ tools.formatTime(event.end.toString()) }}</div>
      </div>
    </div>
    }
  </div>
</div>
}
